var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodeEditorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H4C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H28C30.2091 32 32 30.2091 32 28V4C32 1.79086 30.2091 0 28 0Z",
    fill: "#F0F5F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93312 22C8.68564 22 8.44828 21.9017 8.27329 21.7267C8.0983 21.5517 8 21.3143 8 21.0668V10.9332C8 10.6857 8.0983 10.4483 8.27329 10.2733C8.44828 10.0983 8.68564 10 8.93312 10H23.0709C23.3177 10.0011 23.554 10.0998 23.7281 10.2747C23.9023 10.4496 24 10.6864 24 10.9332V21.0695C23.9989 21.3156 23.9007 21.5513 23.7267 21.7254C23.5527 21.8994 23.317 21.9976 23.0709 21.9987L8.93312 22ZM9.03173 20.9722H22.9723V11.0332H9.03173V20.9722ZM14.5684 19.2931L16.4072 12.4276L17.4323 12.7022L15.5934 19.5677L14.5684 19.2931ZM17.9189 17.8594L19.7758 15.9983L17.9189 14.1386L18.664 13.3888L21.272 15.997L18.664 18.6066L17.9189 17.8594ZM10.732 15.997L13.34 13.3888L14.0885 14.1373L12.2316 15.997L14.0885 17.858L13.34 18.6066L10.732 15.997Z",
    fill: "#203662"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeEditorIcon);
export default __webpack_public_path__ + "static/media/code_editor_icon.0f7a9612c38e144b5210f315bba60b91.svg";
export { ForwardRef as ReactComponent };